import { create } from "zustand"

export const useImageStore = create((set) => ({
    content: "./empty.png",
    updateContent: (newContent) => set((state) => ({ content: newContent }))
}))
